import  React from 'react'

import '../css/button.css'

export const Button=()=>{
    return(
        <button type="button" className=" animated-button" data-bs-toggle="modal" data-bs-target="#myModal">
            <p>Зареєструвати код</p>
        </button>
    )
}